/**
 * API Gateway
 * API Gateway Единая точка входа для android, ios и web.  Модели ответов сервиса соответствуют спецификации, кроме случаев, когда возможны технические ответы (например, от ratelimiter или qrator). 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Вид клиента
 */
export type LegalEntityType = 'Головное предприятие' | 'Филиал' | 'Подразделение';

export const LegalEntityType = {
    Main: 'Головное предприятие' as LegalEntityType,
    Branch: 'Филиал' as LegalEntityType,
    Subdivision: 'Подразделение' as LegalEntityType
};

